import type { TranslationDict } from '../en';

const bg: TranslationDict = {
  'header.buy': 'Купи',
  'header.sell': 'Продай',
  'spend.label': 'Вие харчите',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Вие получавате',
  'payment.label': 'Начин на плащане',
  'payment.select': 'Изберете',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Няма налични начини на плащане за тази двойка',
  'wallet.label': 'Адрес на портфейла за получаване',
  'wallet.placeholderBuy': 'Въведете адреса за получаване',
  'wallet.placeholderSell': 'Въведете адреса за изпращане',
  'wallet.validating': 'Проверка на адреса...',
  'wallet.invalid': 'Въведете валиден адрес на портфейл',
  'wallet.invalidServer': 'Невалиден адрес на портфейл',
  'cta.buy': 'Купи {crypto}',
  'cta.sell': 'Продай {crypto}',
  'cta.gettingPrice': 'Търсене на най-добра цена...',
  'cta.processing': 'Обработка...',
  'footer.poweredBy': 'Предоставено от ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Разбивка на курса',
  'rate.close': 'Затвори',
  'rate.updatesIn': 'Курсът се обновява след 00:{seconds}',
  'rate.noQuote': 'Няма налична оферта',
  'rate.exchangeRate': 'Обменен курс',
  'rate.processingFee': 'Такса за обработка',
  'rate.networkFee': 'Мрежова такса',
  'rate.provider': 'Доставчик',
  'toast.orderCreated': 'Поръчката е създадена',
  'toast.redirecting': 'Пренасочване към плащане...',
  'toast.orderFailed': 'Поръчката е неуспешна',
  'toast.couldNotCreate': 'Неуспешно създаване на поръчка',
  'toast.quoteError': 'Грешка при офертата',
  'toast.noProviders': 'Няма доставчици',
  'toast.somethingWrong': 'Нещо се обърка',
  'error.amountZero': 'Сумата трябва да е по-голяма от 0',
  'error.minAmountFiat': 'Минималната сума е {min} {currency}',
  'error.minAmountCrypto': 'Минималната сума е {min} {currency}',
  'error.noProviders': 'Няма налични доставчици за тази комбинация',
  'error.currencyUnavailableBuy': 'Тази валута не е налична за покупки',
  'error.currencyUnavailableSell': 'Тази валута не е налична за продажби',
  'parity.info': 'Ще бъдете таксувани за {receiveAmount} {crypto}, останалото до {spendAmount} {fiat} ще бъде кредитирано по вашия акаунт в {partner}',
  'redirect.secureBadge': 'Сигурно плащане',
  'redirect.title': 'Продължи плащането',
  'redirect.description': 'Ще бъдете пренасочени към {gateway}, за да завършите плащането.',
  'redirect.countdown': 'Пренасочване след {seconds}...',
  'redirect.openTab': 'Отвори ACH в нов раздел',
  'redirect.cancel': 'Отказ',
  'checkout.noOrder': 'Поръчката не е намерена',
  'checkout.goBack': 'Назад',
  'checkout.expired': 'Сесията за плащане е изтекла',
  'checkout.expiredDesc': 'Сесията е изтекла. Моля, опитайте отново.',
  'checkout.startOver': 'Започни отначало',
  'checkout.cancel': 'Отказ',
  'checkout.loading': 'Зареждане на плащане...',
  'checkout.iframeTitle': 'Плащане при доставчика',
  'checkout.widgetTitle': 'Каса за плащане',
  'checkout.unknownMethod': 'Непознат метод за плащане',
  'processing.default': 'Обработка на вашата поръчка...',
  'processing.pending': 'Изчакване на потвърждение на плащането...',
  'processing.active': 'Обработка на вашата транзакция...',
  'processing.generic': 'Обработка...',
  'processing.checkingStatus': 'Проверка на статуса...',
  'processing.orderId': 'Идентификатор на поръчката',
  'processing.provider': 'Доставчик',
  'processing.amount': 'Сума',
  'processing.receiving': 'Получавате',
  'processing.network': 'Мрежа',
  'processing.toAddress': 'До адрес',
  'processing.usuallyMinutes': 'Това обикновено отнема няколко минути.',
  'processing.safeToClose': 'Можете безопасно да затворите тази страница — ще ви изпратим имейл при завършване.',
  'complete.buyTitle': 'Покупката е завършена!',
  'complete.sellTitle': 'Продажбата е завършена!',
  'complete.buyDesc': 'Вашите {crypto} са изпратени в портфейла ви.',
  'complete.sellDesc': 'Вашето изплащане в {fiat} се обработва.',
  'complete.amountBuy': 'Получена сума',
  'complete.amountSell': 'Продадена сума',
  'complete.paidBuy': 'Платена сума',
  'complete.paidSell': 'Сума за изплащане',
  'complete.network': 'Мрежа',
  'complete.wallet': 'Портфейл',
  'complete.transaction': 'Транзакция',
  'complete.provider': 'Доставчик',
  'complete.orderId': 'Идентификатор на поръчката',
  'complete.completed': 'Завършено',
  'complete.viewExplorer': 'Виж в Explorer',
  'complete.done': 'Готово',
  'errorStep.failed': 'Плащането е неуспешно',
  'errorStep.cancelled': 'Поръчката е отказана',
  'errorStep.expired': 'Поръчката е изтекла',
  'errorStep.refunded': 'Поръчката е възстановена',
  'errorStep.unknown': 'Нещо се обърка',
  'errorStep.failedBuy': 'Плащането ви не можа да бъде обработено. Моля, опитайте отново или използвайте друг начин на плащане.',
  'errorStep.failedSell': 'Продажбата ви не можа да бъде обработена. Моля, опитайте отново.',
  'errorStep.cancelledBuy': 'Поръчката ви беше отказана. Не е извършено плащане.',
  'errorStep.cancelledSell': 'Продажбата ви беше отказана. Не е прехвърлена криптовалута.',
  'errorStep.expiredBuy': 'Поръчката ви е изтекла. Моля, направете нова покупка.',
  'errorStep.expiredSell': 'Поръчката ви е изтекла. Моля, направете нова продажба.',
  'errorStep.refundedBuy': 'Плащането ви е възстановено. Средствата трябва да се появят по вашия акаунт в рамките на 5-10 работни дни.',
  'errorStep.refundedSell': 'Вашата криптовалута е върната. Средствата трябва да се появят в портфейла ви скоро.',
  'errorStep.genericDesc': 'Възникна неочаквана грешка. Моля, опитайте отново.',
  'errorStep.orderId': 'Идентификатор на поръчката',
  'errorStep.tryAgain': 'Опитай отново',
  'errorStep.startOver': 'Започни отначало',
  'errorStep.return': 'Назад',
  'errorStep.needHelp': 'Нужна ви е помощ? Свържете се с ',
  'errorStep.reference': 'Референция: {orderId}',
  'confirm.buyTitle': 'Потвърди покупката',
  'confirm.sellTitle': 'Потвърди продажбата',
  'confirm.loading': 'Зареждане...',
  'confirm.provider': 'Доставчик',
  'confirm.youPay': 'Вие плащате',
  'confirm.youSell': 'Вие продавате',
  'confirm.youReceive': 'Вие получавате',
  'confirm.wallet': 'Портфейл',
  'confirm.network': 'Мрежа',
  'confirm.refundAddress': 'Адрес за възстановяване',
  'confirm.parityNote': 'Таксуваната сума от доставчика може да се различава. Останалото до {amount} {crypto} ще бъде кредитирано по вашия акаунт в {partner}.',
  'confirm.processing': 'Обработка...',
  'confirm.confirmPay': 'Потвърди и плати',
  'confirm.confirmSell': 'Потвърди и продай',
  'confirm.payout': 'Изплащане в {currency}',
  'modal.selectFiat': 'Изберете фиатна валута',
  'modal.selectCrypto': 'Изберете криптовалута',
  'modal.choosePayment': 'Изберете начин на плащане',
  'modal.selectCountry': 'Изберете вашата държава',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Популярни',
  'modal.recommended': 'Препоръчани',
  'modal.noCurrencies': 'Няма намерени валути',
  'modal.noPaymentMethods': 'Няма намерени начини на плащане',
  'modal.noCountries': 'Няма намерени държави',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Местоположение',
  'settings.darkMode': 'Тъмен режим',
  'settings.privacy': 'Политика за поверителност',
  'settings.terms': 'Условия за ползване',
  'settings.language': 'Език',

  // ─── Additional ───
  'modal.chooseRamp': 'Избери Ramp',
  'modal.bestPrice': 'Най-добра цена',
  'modal.noQuotes': 'Няма налични оферти за тази заявка',
  'modal.noProvidersFound': 'Не са намерени доставчици',
  'payment.unavailableFor': 'Няма налични начини на плащане за {currency}',
  'skeleton.poweredBy': 'Предоставено от NowRamp',
  'error.createOrderFailed': 'Неуспешно създаване на поръчка',
  'errorStep.returnToMerchant': 'Обратно към търговеца',
  'confirm.cryptoOnNetwork': '{crypto} на {network}',
  'payment.name.card': 'Карта',
  'payment.name.bankTransfer': 'Банков превод',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default bg;
